/* Cap add-to-cart quantity at 1500 (school spiritwear 500–1000 must pass).
   Also bump qty up to a product MOQ from data-ezink-moq / min. Cart qty 0 still removes. */
(function () {
  var MAX_QTY = 1500;
  function minOf(el) {
    if (!el || !el.getAttribute) return 1;
    var raw = el.getAttribute("data-ezink-moq") || el.getAttribute("min") || "1";
    var m = parseInt(raw, 10);
    return (!m || m < 1) ? 1 : m;
  }
  function isQtyInput(el) {
    if (!el) return false;
    if (el.name === "quantity") return true;
    if (el.hasAttribute && (el.hasAttribute("data-ezink-qty-input") || el.hasAttribute("data-quantity-input"))) return true;
    return false;
  }
  function clampEl(el, allowZero) {
    if (!el) return;
    var n = parseInt(el.value, 10);
    var min = minOf(el);
    if (allowZero && (n === 0 || el.value === "" || el.value === "0")) return;
    if (isNaN(n) || n < min) n = min;
    if (n > MAX_QTY) n = MAX_QTY;
    el.value = String(n);
  }
  document.addEventListener("submit", function (evt) {
    var form = evt.target;
    if (!form || !form.action) return;
    var action = String(form.action);
    if (action.indexOf("/cart/add") !== -1) {
      var qty = form.querySelector("[name='quantity']") || form.querySelector("[data-ezink-qty-input]");
      clampEl(qty, false);
    }
  }, true);
  document.addEventListener("change", function (evt) {
    var el = evt.target;
    if (!isQtyInput(el)) return;
    var allowZero = el.name === "updates[]" || (el.hasAttribute && el.hasAttribute("data-quantity-input"));
    clampEl(el, allowZero);
  });
})();
